import { useBlockProps } from '@wordpress/block-editor';
import { RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { FC } from 'react';

import BlockControls from './block-controls';

interface EditProps {
  attributes: {
    kicker?: string;
    headline?: string;
    headlineLevel?: number;
    textAlign?: string;
    textColor?: string
  };
  className: string;
  setAttributes: (attributes: Record<string, any>) => void;
  isSelected: boolean;
}

const Edit: FC<EditProps> = ({ attributes: { headlineLevel, textAlign, headline, kicker, textColor }, setAttributes }) => {
  return (
    <>
      <BlockControls
        attributes={{
          headlineLevel,
          textAlign,
        }}
        setAttributes={setAttributes}
      />

      <div {...useBlockProps()}>
        <hgroup className={`hgroup ${textAlign != 'left' && `has-text-align${textAlign}`} `}>
        <p className={`kicker ${textColor ? `has-${textColor}-color` : ''}`}>
            <RichText
              value={kicker}
              placeholder={__('Kicker…', 'neodigital')}
              keepplaceholderonfocus="true"
              onChange={(kicker) => setAttributes({ kicker })}
            />
          </p>
          <RichText
            value={headline}
            tagName={`h${headlineLevel}`}
            className="headline"
            placeholder={__('Heading…', 'neodigital')}
            keepplaceholderonfocus="true"
            onChange={(headline) => setAttributes({ headline })}
          />
        </hgroup>
      </div>
    </>
  );
};

export default Edit;
